import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {getGroupFields as getGroupFieldsAPI} from '../../../services/groups'

export async function getGroupFields(dispatch, {group_id, type}) {
  try {
    dispatch({type: PENDING})
    let response = await getGroupFieldsAPI({group_id})

    if (!!type && type.length > 0) {
      console.log(response, type)
      const _types = type.split(',')
      const fields = response.fields.filter(f => _types.indexOf(f.type) !== -1)
      console.log(fields)
      dispatch({type: SUCCESS, payload: {fields: fields}})
    } else {
      dispatch({type: SUCCESS, payload: response})
    }
  } catch (e) {
    console.log(`Get Group Fields Failed: ${group_id}`)
    dispatch({type: FAILURE, payload: e})
  }
}
